<script setup>
import { gsap } from 'gsap';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';
import { computed, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';

gsap.registerPlugin(MorphSVGPlugin);

const route = useRoute();

const tabs = [
  {
    name: 'Accueil',
    icon: 'home.svg',
    iconActive: 'home.svg',
    id: 'home'
  },
  {
    name: 'Services',
    icon: 'services.svg',
    iconActive: 'services.svg',
    id: 'services'
  },
  {
    name: 'Historique',
    icon: 'history.svg',
    iconActive: 'history.svg',
    id: 'history'
  },
  {
    name: 'Pronostics',
    icon: 'pronostics.svg',
    iconActive: 'pronostics.svg',
    id: 'pronostics'
  },
  {
    name: 'Profile',
    icon: 'user.svg',
    iconActive: 'user.svg',
    id: 'profile'
  }
];

const activeTab = computed(() => {
  const activeTab = tabs
    .map((el, i) => ({ ...el, position: i, svgSelector: `#bottom-pos-${i}` }))
    .find((tab) => {
      return route.name == tab.id;
    });
  if (!activeTab) return { svgSelector: '#bototm-pos-none' };
  return activeTab;
});

function animateBottomNav() {
  // gsap.to('#bottom-nav-displayed', {
  //   duration: 0.5,
  //   morphSVG: '#bottom-pos-none'
  // });
  // setTimeout(() => {
  gsap.to('#bottom-nav-displayed', {
    // delay: 0.1,
    duration: 0.2,
    morphSVG: activeTab.value.svgSelector
  });
  // }, 400);
  // findShapeIndex('#bottom-pos-none', '#bottom-pos-0');
}

watch(
  () => activeTab.value,
  () => {
    animateBottomNav();
  }
);

onMounted(() => {
  window.gsap = gsap;
  window.MorphSVGPlugin = MorphSVGPlugin;
  animateBottomNav();
  // setTimeout(() => {
  // }, 3000);
});
</script>

<template>
  <div class="z-10 fixed! bottom-0 w-full drop-shadow-2xl will-change-auto">
    <div class="relative">
      <div class="absolute w-full h-[135%] bottom-0 flex justify-center -mb-1">
        <!-- <div class="absolute right-0 bg-[#070C4C] w-2 h-full"></div> -->
        <svg
          version="1.2"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 402 110"
          class="top-0 absolute w-full"
        >
          <!-- <path
            class="hidden"
            id="bottom-pos-3"
            d="m402 110h-402v-110h304.3q-0.3 2.46-0.3 5c0 23.2 19.03 42 42.5 42 23.47 0 42.5-18.8 42.5-42q0-2.54-0.3-5h13.3z"
          /> -->
          <!-- <path
            class="hidden"
            id="bottom-pos-2"
            d="m402 110h-402v-110h208.3q-0.3 2.46-0.3 5c0 23.2 19.03 42 42.5 42 23.47 0 42.5-18.8 42.5-42q0-2.54-0.3-5h107.3z"
          /> -->
          <!-- <path
            class="hidden"
            id="bottom-pos-1"
            d="m402 110h-402v-110h80q-0.3 2.46-0.3 5c0 23.2 19.03 42 42.5 42 23.47 0 42.5-18.8 42.5-42q0-2.54-0.3-5h206.3z"
          /> -->
          <path
            class="hidden"
            id="bottom-pos-4"
            d="m402 110h-402v-110h306q-0.3 2.46-0.3 5c0 23.2 19.03 42 42.5 42 23.47 0 42.5-18.8 42.5-42q0-2.54-0.3-5h303.3z"
          />
          <path
            class="hidden"
            id="bottom-pos-3"
            d="m402 110h-402v-110h232q-0.3 2.46-0.3 5c0 23.2 19.03 42 42.5 42 23.47 0 42.5-18.8 42.5-42q0-2.54-0.3-5h303.3z"
          />
          <path
            class="hidden"
            id="bottom-pos-2"
            d="m402 110h-402v-110h158q-0.3 2.46-0.3 5c0 23.2 19.03 42 42.5 42 23.47 0 42.5-18.8 42.5-42q0-2.54-0.3-5h303.3z"
          />
          <path
            class="hidden"
            id="bottom-pos-1"
            d="m402 110h-402v-110h84q-0.3 2.46-0.3 5c0 23.2 19.03 42 42.5 42 23.47 0 42.5-18.8 42.5-42q0-2.54-0.3-5h303.3z"
          />
          <path
            class="hidden"
            id="bottom-pos-0"
            d="m402 110h-402v-110h10q-0.3 2.46-0.3 5c0 23.2 19.03 42 42.5 42 23.47 0 42.5-18.8 42.5-42q0-2.54-0.3-5h313.3z"
          />
          <path
            id="bottom-pos-none"
            class="hidden"
            d="m402 110h-402v-110h71.87 88.75 46.5 63.91 75.97 55z"
          />
          <path
            class="fill-[#070C4C] will-change-auto"
            id="bottom-nav-displayed"
            d="m402 110h-402v-110h71.87 88.75 46.5 63.91 75.97 55z"
          />
        </svg>
      </div>
      <div class="w-full grid grid-cols-5 justify-around px-5 md:hidden pb-6!">
        <div
          v-for="(tab, i) in tabs"
          @click="
            () => {
              tab.event && $bus.emit(tab.event);
            }
          "
        >
          <component
            :is="tab.id ? 'router-link' : 'div'"
            :to="`${tab.id}`"
            class="flex flex-col items-center gap-3 rounded-2xl duration-300 relative"
            :class="{
              'text-white': activeTab.id == tab.id,
              'text-white ': activeTab.id !== tab.id
            }"
          >
            <div
              class="duration-300 w-7 h-7 relative rounded-full flex items-center justify-center"
            >
              <div
                class="duration-300 absolute delay-200- flex items-center justify-center will-change-auto"
                :class="{
                  ' w-[18vw] h-[18vw] -translate-y-[37%]  bg-[#FA7607]  rounded-full scale-[1] ':
                    activeTab.id == tab.id,
                  ' w-full h-full   translate-y-2 ': activeTab.id !== tab.id
                }"
              >
                <div
                  class="relative duration-300 delay-200- will-change-auto"
                  :class="{
                    'text-white w-[55%] h-[55%] ': activeTab.id == tab.id,
                    'text-[#ccc]  w-full h-full': activeTab.id !== tab.id
                  }"
                >
                  <ColorImg
                    :class="{
                      'opacity-100': activeTab.id == tab.id,
                      'opacity-0': activeTab.id !== tab.id
                    }"
                    :src="`/images/navs/${tab.iconActive}`"
                    class="bg-current absolute top-0 left-0 duration-300 delay-200- w-full h-full will-change-auto"
                  />
                  <ColorImg
                    :class="{
                      'opacity-0': activeTab.id == tab.id,
                      'opacity-100': activeTab.id !== tab.id
                    }"
                    :src="`/images/navs/${tab.icon}`"
                    class="bg-current absolute top-0 left-0 duration-300 delay-200- w-full h-full will-change-auto"
                  />
                </div>
              </div>
            </div>
            <div
              class="w-full text-center text-xs duration-300 will-change-auto font-bold opacity-100"
              :class="{
                'translate-y-2': activeTab.id == tab.id,
                'translate-y-2 visible': activeTab.id !== tab.id
              }"
            >
              {{ tab.name }}
            </div>
          </component>
        </div>
      </div>
    </div>
    <div class="mobile-bottom-padding bg-[#070C4C] relative"></div>
  </div>
</template>
